<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-container">
    <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
      <colgroup>
        <col *ngFor="let col of tableHeader" [width]="col.width"/>
      </colgroup>
      <thead>
        <tr>
          <th *ngFor="let header of tableHeader" [sortable-column]="header.value"> 
            <div>{{header.name}}</div>
          </th>
        </tr>
      </thead>
    </table>
    <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"> <i class="material-icons">inventory_2</i>
      <div>No Data</div>
    </div>
    <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
      <div>Permission Denied</div>
    </div>
    <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
      <table>
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <tbody>
          <tr class="has-child" *ngFor="let type of incidentTypeList" (click)="goToDetail(type)">
            <td>{{type.name}}</td>
            <td> 
              <div class="v-center" style="gap: 8px">
                <div class="sub-category" *ngFor="let subCategory of type.incident_categories">
                   {{ subCategory.name }}</div>
              </div>
            </td>
            <td>
              <div class="more-content v-center" #actionMenus [id]="'type-'+type?.id" (mouseenter)="setMorePosition(type)">
                <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(type)">
                  <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                </div>
                <div class="more" [class.show]="type.isShowMenu" [id]="'type-more-'+type.id">
                  <div class="more-item row" (click)="goToDetail(type)">
                    <div>Go to Detail</div>
                  </div>
                  <div class="more-item row txt-primary" (click)="openEditDialog($event, type)">
                    <div>Edit</div>
                  </div>
                  <div class="more-item row txt-danger" (click)="openDeleteDialog($event, type)">
                    <div>Delete</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-container>